import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styled from 'styled-components';
import { colors } from '../../../style';
import { ButtonProps } from '../../button/button';

export interface AppSwitcherNavButtonProps extends ButtonProps {
  className?: string;
  to?: string;
  children?: React.ReactNode | string;
  href?: string;
  componentClass?: React.ElementType;
  disabled?: boolean;
  exact?: boolean;
}

const StyledAppSwitcherNavButton = styled.button<AppSwitcherNavButtonProps>`
  height: 100%;
  width: 100%;
  color: ${colors.gray900};
  text-decoration: none;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  border: 1px solid transparent;
  padding: 8px 8px;
  align-items: center;
  border-radius: 4px;
  font-weight: 400;
  background: transparent;
  transition: 0.3s;

  &:hover:not([disabled]) {
    background: ${props => props.theme.actionLight};
  }

  &:focus-visible {
    background: ${props => props.theme.actionLight};
    border: 1px solid transparent;
  }

  &:active {
    background: ${props => props.theme.actionLight};
  }

  &:not([disabled]) {
    cursor: pointer;
  }

  &[disabled] {
    cursor: not-allowed;
    background: ${colors.gray400};
    color: ${colors.gray900};
  }

  &.active {
    &,
    > * {
      font-weight: 500;
    }
  }
`;

const AppSwitcherNavButton = ({ className, to, href, children, ...rest }: AppSwitcherNavButtonProps) => {
  return (
    // @ts-ignore
    <StyledAppSwitcherNavButton
      className={classNames('navbar-button', className)}
      as={href ? 'a' : to ? NavLink : undefined}
      to={to}
      weight={400}
      href={href}
      {...rest}
    >
      {children}
    </StyledAppSwitcherNavButton>
  );
};

AppSwitcherNavButton.displayName = 'AppSwitcherNavButton';
export default AppSwitcherNavButton;
